import { Container, Stack } from '@mantine/core';
import BreadcrumbsComponent from 'components/BreadcrumbsComponent';
import CompetencyInformation from 'modules/pages/dacum/reviewMasterplan/CompetencyInformation';
import KeyActionInformation from 'modules/pages/dacum/reviewMasterplan/KeyActionInformation';
import React from 'react';
import { pathnames } from 'routes/dacum';

const DetailReviewMasterPlanPage = () => {
  const breadcrumbs = [
    { title: 'Review Masterplan', href: pathnames.reviewMasterPlan },
    { title: 'Detail Review Master Plan', href: '' }
  ];
  return (
    <Container fluid>
      <BreadcrumbsComponent items={breadcrumbs} mb={32} />

      <Stack gap={16} mt={32}>
        <CompetencyInformation />
        <KeyActionInformation />
      </Stack>
    </Container>
  );
};

export default DetailReviewMasterPlanPage;
